import { useContext } from 'react';
import segment from '@services/segment';
import { analytics } from '@services/analytics';
import { UserContext } from '@services/Session';
import {
  GameStartEvent,
  GameActionUserType,
} from '@features/Schedule/schedule.d';

import { EventProps } from '@services/segment';

const useEventsGameStart = (
  teamId?: string,
  sportType?: string,
  isAdmin?: boolean
) => {
  const userStore = useContext(UserContext);
  const getUserType = () => {
    if (isAdmin) {
      return GameActionUserType.ADMIN;
    } else if (userStore.authUser?.claims?.shd_user_id) {
      return GameActionUserType.COMMUNITY_MEMBER;
    } else if (userStore.authUser) {
      return GameActionUserType.LOGGED_IN;
    } else {
      return GameActionUserType.LOGGED_OUT;
    }
  };

  const trackGameStartEvent = (event: GameStartEvent, props?: EventProps) => {
    if (import.meta.env.MODE !== 'test') {
      analytics.track(event, {
        teamId,
        sport: sportType,
        userType: getUserType(),
        ...props,
      });
      segment.track(event, {
        teamId,
        sport: sportType,
        userType: getUserType(),
        ...props,
      });
    }
  };

  return {
    trackGameStartEvent,
  };
};

export default useEventsGameStart;
